export interface Reference {
  id: string;
  customerId: string;
  name: string;
  address: string;
  city: string;
  stateId?: string;
  zip: string;
  homePhone: string;
  cellPhone: string;
  emailAddress: string;
  callable: boolean;
  customerReferenceRelationshipId?: string;
  modifiedDate: Date;
  note: string;
  livesWith: boolean; // whether or not the reference lives with the customer
  sentToAmsDate?: Date;
  sentToAmsById?: string;
}

export interface CreateUpdateReference {
  id?: string;
  customerId: string;
  name: string;
  address: string;
  city: string;
  stateId?: string;
  zip: string;
  homePhone: string;
  cellPhone: string;
  emailAddress: string;
  callable: boolean;
  customerReferenceRelationshipId?: string;
  note: string;
  livesWith: boolean; // whether or not the reference lives with the customer
}

export const emptyReference: Reference = {
  id: '',
  customerId: '',
  name: '',
  address: '',
  city: '',
  stateId: '',
  zip: '',
  homePhone: '',
  cellPhone: '',
  emailAddress: '',
  callable: false,
  customerReferenceRelationshipId: undefined,
  modifiedDate: new Date(),
  note: '',
  livesWith: false,
};